import { generateJSON } from '@tiptap/html'
import { activeTipTapExtensions } from './activeTipTapExtensions.mjs'
import { getBucketFileIdsFromContent } from './getBucketFileIdsFromContent.mjs'

export function getBucketFileIdsFromHtml(htmlString) {
  const jsonNode = generateJSON(htmlString, activeTipTapExtensions.get())
  const result = new Set()
  return getBucketFileIdsFromContent(jsonNode, result)
}
